var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Breadcrumbs',{attrs:{"main":"","title":_vm.$t("lbl_EMPBE_DowloadCenter")}}),_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},_vm._l((_vm.downloads),function(download,index){return _c('Donwloads',{key:index,attrs:{"data":download}})}),1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }